import React from 'react';
import './QuestionItem.css';

export interface Question {
  id: string;
  question: string;
  type: 'true_false' | 'multiple_choice';
  options: string[] | Record<string, string>;
  correctAnswer: string | boolean;
  explanation?: string;
}

export interface QuestionItemProps {
    question: Question;
    questionIndex: number;
}

const QuestionItem: React.FC<QuestionItemProps> = ({ question, questionIndex }) => {
    const renderOptions = () => {
        if (Array.isArray(question.options)) {
            return question.options.map((option: string, index: number) => (
                <div key={index} className="question-option">
                    <span className="question-option-label">{String.fromCharCode(65 + index)}.</span>
                    <span className="question-option-text">{option}</span>
                </div>
            ));
        } else {
            return Object.entries(question.options).map(([key, value]) => (
                <div key={key} className="question-option">
                    <span className="question-option-label">{key}.</span>
                    <span className="question-option-text">{String(value)}</span>
                </div>
            ));
        }
    };

    return (
        <div className="content-item rounded-card-compact">
            <p className="question-text">
                <strong>Question {questionIndex + 1}:</strong> {question.question}
            </p>
            
            <div className="question-options">
                {renderOptions()}
            </div>
            
            <div className="question-option correct">
                <span className="question-option-label">✓</span>
                <span className="question-option-text">
                    <strong>Correct Answer:</strong> {typeof question.correctAnswer === 'boolean' ? (question.correctAnswer ? 'True' : 'False') : question.correctAnswer}
                </span>
            </div>
            
            {question.explanation && (
                <div className="content-explanation">
                    <h4 className="content-explanation-title">Explanation</h4>
                    <p>{question.explanation}</p>
                </div>
            )}
        </div>
    );
};

export default QuestionItem; 